module.exports = __webpack_public_path__ + "img/logo.36157c05.png";